import { FormikProps } from 'formik';
import { AddFieldValues } from '../AddFieldTemplateDialog';
import ConditionEditor from './ConditionConfig/ConditionEditor';
import { TabPanel } from '@mui/lab';

interface ConditionsConfigTabProps {
  formik: FormikProps<AddFieldValues>;
  disabled: boolean;
}

export default function ConditionsConfigTab({
  formik,
  disabled,
}: ConditionsConfigTabProps) {
  return (
    <TabPanel value="2" sx={{ p: 0, pt: 2, minHeight: 500 }}>
      <ConditionEditor
        onChange={group => formik.setFieldValue('isVisibleConditions', group)}
        rootGroup={formik.values.isVisibleConditions}
        errors={formik.errors}
        disabled={disabled}
      />
    </TabPanel>
  );
}
